<template>
  <div id="kvkk-modal" class="uk-modal-container" uk-modal>
    <div class="uk-modal-dialog uk-modal-body">
      <button class="uk-modal-close-default" type="button" uk-close></button>
      <h2 class="uk-modal-title" v-text="title"></h2>
      <div v-html="content"></div>
      <div class="uk-alert uk-alert-primary uk-text-center" v-if="title == null">
        <div uk-spinner="ratio: 2"></div>
        <p class="uk-text-lead uk-text-primary">Yükleniyor</p>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
export default {
  name: "KvkkModal",
  data(){
    return {
      title : null,
      content : null
    }
  },
  created(){
    Axios.get("https://bsapp.dev/QuizApp/api/kvkk")
    .then(response => {
      this.title = response.data.title,
      this.content = response.data.content
    })
    .catch(e => {
      console.log(e)
    })
  }
}
</script>
<style scoped>
</style>